"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reactive_vue_1 = require("@formily/reactive-vue");
var vue_1 = require("@formily/vue");
var vue_demi_1 = require("vue-demi");
// @ts-ignore
var index_vue_1 = __importDefault(require("@/components/UserSelect/index.vue"));
var formilyUserContact = (0, reactive_vue_1.observer)((0, vue_demi_1.defineComponent)({
    name: 'userSelect',
    props: ['value'],
    setup: function (curProps, _a) {
        var attrs = _a.attrs, emit = _a.emit;
        var field = (0, vue_1.useField)().value;
        // 配置面板的开关统一放在 componentProps 中，显式透传，避免被 attrs 覆盖
        var data = field.componentProps || {};
        return function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return (0, vue_1.h)(index_vue_1.default, {
                attrs: __assign(__assign(__assign(__assign({}, curProps), { selected: curProps.value }), attrs), { 
                    // 配置面板开关：显式传入优先，其次取 componentProps，最后默认关闭。
                    // 放在 ...attrs 之后，确保不会被同名 undefined 覆盖。
                    requestOptimize: (_b = (_a = attrs.requestOptimize) !== null && _a !== void 0 ? _a : data.requestOptimize) !== null && _b !== void 0 ? _b : false, oaOnly: (_d = (_c = attrs.oaOnly) !== null && _c !== void 0 ? _c : data.oaOnly) !== null && _d !== void 0 ? _d : false, clearable: (_f = (_e = attrs.clearable) !== null && _e !== void 0 ? _e : data.clearable) !== null && _f !== void 0 ? _f : false, allowPaste: (_h = (_g = attrs.allowPaste) !== null && _g !== void 0 ? _g : data.allowPaste) !== null && _h !== void 0 ? _h : false, multiple: (_k = (_j = attrs.multiple) !== null && _j !== void 0 ? _j : data.multiple) !== null && _k !== void 0 ? _k : false, enableTencentStaffName: (_m = (_l = attrs.enableTencentStaffName) !== null && _l !== void 0 ? _l : data.enableTencentStaffName) !== null && _m !== void 0 ? _m : false }),
                on: {
                    'user-select-change': function (val) {
                        emit('change', val);
                    },
                },
            }, {
                default: function () { return [curProps.value || attrs.content]; },
            });
        };
    },
}));
exports.default = formilyUserContact;
